


































































































































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import Pill from "@/shared/components/ui/Pill.vue";
import {
  CensusUploadStatus,
  EmployerCensusFile,
  CensusUploadType
} from "@/employer/types";
import { useUserStore } from "@/shared/store/user";
import { useCensusFileStore } from "@/employer/store/censusFile";

@Component({
  components: {
    Pill
  }
})
export default class CensusFileUploadResultsPanel extends Vue {
  $validator: Validator;

  userStore = useUserStore();
  censusFileStore = useCensusFileStore();

  get employerId (): number {
    if (this.userStore.currentEmployer && this.userStore.currentEmployer.employerId) {
      return this.userStore.currentEmployer.employerId;
    }

    return 0;
  }

  get displayFileSummaryPanel (): boolean {
    return this.censusFileStore.fileDetailsLoaded && this.censusFileStore.selectedFileDetails !== undefined;
  }

  get displayFileProcessingMessage (): boolean {
    return this.displayFileSummaryPanel && this.censusFileStore.selectedFileDetails.uploadStatus ===
        CensusUploadStatus.Pending;
  }

  get selectedPanelBorderClass (): string {
    return this.displayFileSummaryPanel ? "selected-panel-border" : "";
  }

  selectFile (event, file: EmployerCensusFile): void {
    event.preventDefault();
    this.censusFileStore.loadFileDetails({ censusFileId: file.employerCensusFileId, employerId: this.employerId });
  }

  getTotalSuccessRecordsCount (fileDetails: EmployerCensusFile): number {
    return fileDetails.newUserCount + fileDetails.updatedUserCount + fileDetails.unchangedUserCount;
  }

  getTotalUserCount (fileDetails: EmployerCensusFile): number {
    return this.getTotalSuccessRecordsCount(fileDetails) + fileDetails.errorCount;
  }

  getPillClass (status: CensusUploadStatus): string {
    switch (status) {
      case CensusUploadStatus.Pending: {
        return "neutral-pill";
      }
      case CensusUploadStatus.Fail: {
        return "error-pill";
      }
      case CensusUploadStatus.SomeErrors: {
        return "warning-pill";
      }
      default: {
        return "success-pill";
      }
    }
  }

  getStatusText (status: CensusUploadStatus): string {
    switch (status) {
      case CensusUploadStatus.NoErrors: {
        return "No Errors";
      }
      case CensusUploadStatus.SomeErrors: {
        return "Some Errors";
      }
      default: {
        return status;
      }
    }
  }

  getTypeText (status: CensusUploadType): string {
    switch (status) {
      case CensusUploadType.Web: {
        return "Web";
      }
      case CensusUploadType.Sftp: {
        return "SFTP";
      }
      default: {
        return "None";
      }
    }
  }

  isResultFileDownloadDisabled (file: EmployerCensusFile): boolean {
    return !file ||
        !file.uploadStatus ||
        file.uploadStatus === CensusUploadStatus.None ||
        file.uploadStatus === CensusUploadStatus.Pending;
  }

  resultFileDownloadButtonText (file: EmployerCensusFile): string {
    return this.isResultFileDownloadDisabled(file) ? "Waiting" : "Results File";
  }

  onResultFileDownloadClick (file: EmployerCensusFile): void {
    this.censusFileStore.downloadCensusFileResult({
      employerId: this.employerId,
      censusFileId: file.employerCensusFileId
    });
  }
}
